import { gql, useMutation } from '@apollo/client';

import {
  RejectLead,
  RejectLeadVariables,
} from '../../../graphql/athena/mutations/__generated__/RejectLead';
import { LWC_DETAILS_FOR_BROKERAGE_QUERY } from '../queries/BrokerageLwcDetails';
import { LWC_DETAILS_QUERY } from '../queries/LwcDetails';
import { PARN_DETAILS_QUERY } from '../queries/ParnDetails';

export const REJECT_LISTING_LEAD = gql`
  mutation RejectLead($agentCustomerUuid: String!, $agentListingLeadId: String!) {
    odProtosAgentsServicesAgentlead {
      rejectLead(input: { agentLeadId: $agentListingLeadId, agentCustomerId: $agentCustomerUuid }) {
        lead {
          id
        }
      }
    }
  }
`;

/** Reject a lead for a listing, this should put it back as a potential candidate for agent assignment */
export const useRejectListingLead = () => {
  const [rejectListingLead, { data, error, loading }] = useMutation<
    RejectLead,
    RejectLeadVariables
  >(REJECT_LISTING_LEAD, {
    fetchPolicy: 'no-cache',
    context: {
      clientName: 'athena',
    },
    refetchQueries: [LWC_DETAILS_QUERY, LWC_DETAILS_FOR_BROKERAGE_QUERY, PARN_DETAILS_QUERY],
  });
  const rejectLead = async (agentCustomerUuid: string, agentListingLeadId: string) =>
    await rejectListingLead({
      variables: { agentCustomerUuid, agentListingLeadId },
    });
  return { rejectLead, data, loading, error };
};
